<template>
    <div>
        <view-item v-if="!!template" :template_id="template.id" @success="alertSuccess" @delete-item="deleteType"
            @cancel="template = null"></view-item>

        <list-items v-else :title="$translate('templates')" @show-item="evt => showTemplate(evt)" ref="table">
            <b-button block variant="primary" v-if="hasPermissionCreate" @click=" showTemplate()"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'activityTemplates',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            template: null,
        }
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('orderCategory/fetchAll')
        this.$store.dispatch('transactionType/fetchAll')
    },
    mounted() {
        // this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('activity_template') },
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return templates
        },
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        types() {
            const items = this.$store.state.orderType.items
            console.log('items', items)
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
       async doSearch() {
           await this.$store.dispatch('orderTemplate/fetchAll')
        },

        async showTemplate(id) {
            if (id) {
                this.template = this.templates.find(x => x.id === id)
              await this.$store.dispatch('orderTemplate/fetchById', id)
            } else {
                const newItem = {
                    id: null,
                    order_category_id: null,
                    name: null,
                    description: null,
                    order_type_id: null,
                    secondary_order_type_id: null,
                    items: [],
                }
                this.template = newItem
                this.$store.commit('orderTemplate/set_template', newItem)
            }
        },

        alertSuccess(action, name, message) {
            this.genericToast(this.componentName, this.$translate(`${action}d`), 'success', `"${name}" ${message}`)
            if(action != 'create') {
                this.template = null
                this.doSearch()
            }
        },
    },
}
</script>
<style></style>
